import { render, staticRenderFns } from "./BundleAdd.vue?vue&type=template&id=a5af0fbe"
import script from "./BundleAdd.vue?vue&type=script&lang=js"
export * from "./BundleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports